import React from 'react';
import { FaBars } from 'react-icons/fa';
import { saveAs } from 'file-saver';

const Header = ({ toggleSideBar }) => {
    const saveFile = (file) => {
        saveAs(file, 'Stephen Olayemi CV.pdf');
    };
    return (
        <div className="flex justify-between fixed w-full shadow-lg z-40 bg-white items-center p-3 text-xl">
            <i
                onClick={toggleSideBar}
                className="text-teal-900 px-3 block lg:hidden cursor-pointer"
            >
                <FaBars />
            </i>
            <i
                onClick={() => saveFile(require('../../Stephen CV.pdf'))}
                className="text-teal-900 px-3 cursor-pointer"
            >
                Download CV
            </i>
        </div>
    );
};

export default Header;
